module.exports = __webpack_public_path__ + "img/WFH-AGS-2025-Logo-ES.19deb167.png";